<span class="am-flex-align am-flex-1 gap-xs overflow" (click)="openRoom.emit()">
  <span class="am-flex-align relative">
    <span class="circle-xxxl am-flex-center color-white font-s font-500 uppercase" [ngClass]="room | avatarColor">{{ room?.owner?.initials }}</span>
    <span class="absolute bottom-0 right-0 circle-s circle-i b-width-2" [ngClass]="[room?.owner?.isOnline ? 'bg-green' : 'bg-secondary', isActive ? 'b-white' : 'b-basic-grey']"></span>
  </span>
  <span class="am-flex-column am-flex-1 overflow">
    <span class="am-flex-align gap-xxs">
      <span class="ellipsis font-500" [class.bold]="room?.unreadMessagesCount" [class.color-blue]="isActive">{{ room?.roomName || '-' }}</span>
      @if (room?.isParticipant) { <span class="am-flex-center icon-user-tick font-l color-blue"></span> }
    </span>
    <span class="ellipsis font-s" [class.color-disabled]="!preview" [class.color-title-grey]="preview && room?.unreadMessagesCount">{{ preview || 'Keine Nachrichten' }}</span>
  </span>
</span>

<span class="am-flex-column am-flex-align-center am-flex-justify-end am-flex-align-self-stretch am-flex-shrink-0 width-30 gap-xxs">
  @if (room?.unreadMessagesCount) {
    <span class="am-flex-center width-30 height-18 b-radius-wide font-s roboto" [ngClass]="highlightRoom() ? 'bg-blue color-white' : 'bg-white b-grey'">{{ room?.unreadMessagesCount > 99 ? '99+' : room?.unreadMessagesCount }}</span>
  }
  <span class="font-xs color-secondary-grey word-no-wrap roboto">{{ getMessageTime(room?.latestMessage) }}</span>
</span>

<span class="relative am-flex-center stop-hover">
  <span class="am-flex-center font-l-i icon-dots p-xs b-radius hover-bg-soft-blue" [ngClass]="menuOpen ? 'bg-light-blue color-blue' : ''" role="button" aria-label="Mehr" [attr.aria-expanded]="!!menuOpen" (click)="toggleMenu()"></span>
  @if (menuOpen) {
    <div class="absolute right-0 z-3 width-165 am-flex-column bg-white b-grey b-radius-wide shadow p-xxs font-s" [ngClass]="menuUp ? 'bottom-full mb-xxs' : 'top-full mt-xxs'">
      <span class="am-flex-align gap-xs height-36 pl-xs pr-xs b-radius hover-active-bg" (click)="readAll()">
        <span class="am-flex-center icon-ticks font-l"></span>
        <span>Alles lesen</span>
      </span>
      @if (room?.isParticipant) {
        <span class="bt-grey mt-xxs mb-xxs ml-xxs mr-xxs"></span>
        <span class="am-flex-align gap-xs height-36 pl-xs pr-xs b-radius hover-active-bg color-red" (click)="leaveHandler()">
          <span class="am-flex-center icon-exit font-l"></span>
          <span>Chat verlassen</span>
        </span>
      }
    </div>
  }
</span>
